import {getExternalI18n, i18n} from '../plugins/i18n/i18n';

const SUPPORTED_LOCALES = ['en-GB', 'fr-BE', 'de-BE', 'nl-BE'];
const CURRENCY_FORMAT_KEYS = ['price', 'priceWithoutDecimal'];

function buildCurrencyFormats(currency) {
  return CURRENCY_FORMAT_KEYS.reduce((formats, formatKey) => {
    const formatOptions = {
      style: 'currency',
      currency,
      // fr-BE + GBP defaults to "£GB" without this (Intl locale data quirk)
      currencyDisplay: 'narrowSymbol',
    };
    if (formatKey === 'priceWithoutDecimal') {
      formatOptions.maximumFractionDigits = 0;
    }
    formats[formatKey] = formatOptions;
    return formats;
  }, {});
}

function applyToI18nInstance(instance, currency) {
  const mergeNumberFormat = instance?.global?.mergeNumberFormat;
  if (!mergeNumberFormat) {
    return;
  }
  const currencyFormats = buildCurrencyFormats(currency);
  SUPPORTED_LOCALES.forEach((locale) => {
    mergeNumberFormat.call(instance.global, locale, currencyFormats);
  });
}

export function applyCompanyCurrency(currency = 'EUR') {
  const externalI18n = getExternalI18n();
  if (externalI18n) {
    applyToI18nInstance(externalI18n, currency);
  } else {
    applyToI18nInstance(i18n, currency);
  }
}
